/* eslint-disable no-async-promise-executor */
import readImageAsDataUrl from '@/lib/utils/readImageAsDataUrl';

const IMAGE_TARGET_MAX_SIZE = 1920;

export class ImageResizeError extends Error {}

const computeNewImageSize = (img: HTMLImageElement): [number, number] => {
  const imageIsLandscape = img.width > img.height;

  if (imageIsLandscape) {
    const imageAspectRatio = img.height / img.width;

    return [
      IMAGE_TARGET_MAX_SIZE,
      Math.round(IMAGE_TARGET_MAX_SIZE * imageAspectRatio),
    ];
  }

  const imageAspectRatio = img.width / img.height;

  return [
    Math.round(IMAGE_TARGET_MAX_SIZE * imageAspectRatio),
    IMAGE_TARGET_MAX_SIZE,
  ];
};

const downsizeImage = (imageFile: File): Promise<File> => {
  return new Promise(async (resolve, reject): Promise<void> => {
    const imageAsDataUrl = await readImageAsDataUrl(imageFile);

    const img = document.createElement('img');

    img.onload = (): void => {
      if (
        img.width <= IMAGE_TARGET_MAX_SIZE &&
        img.height <= IMAGE_TARGET_MAX_SIZE
      ) {
        resolve(imageFile);

        return;
      }

      const canvas = document.createElement('canvas');
      const canvasContext = canvas.getContext('2d');

      if (canvasContext === null) {
        resolve(imageFile);

        return;
      }

      const [newImageWidth, newImageHeight] = computeNewImageSize(img);

      canvas.width = newImageWidth;
      canvas.height = newImageHeight;

      canvasContext.drawImage(img, 0, 0, newImageWidth, newImageHeight);

      canvas.toBlob((downsizedImageBlob: Blob | null): void => {
        if (downsizedImageBlob === null) {
          resolve(imageFile);

          return;
        }

        const downsizedImageFile = new File(
          [downsizedImageBlob],
          imageFile.name,
          {
            lastModified: imageFile.lastModified,
          },
        );

        resolve(downsizedImageFile);
      }, imageFile.type);
    };

    img.onerror = () => {
      reject(new ImageResizeError());
    };

    img.src = imageAsDataUrl;
  });
};

export default downsizeImage;
